import { Outlet } from "react-router-dom";

const SafetyInformationBoardPageLayout = () => {
    return (
        <><Outlet /></>
    );
};

export default SafetyInformationBoardPageLayout;
